/**
 * Custom Posts JS
 */

// CSS
import styles from '../scss/custom-posts.scss';
const $ = window.jQuery;
